import { toast } from "react-toastify";
import {HTTPURL} from '../../constants/Matcher';

const getBranchId = () => {
    const raw = localStorage.getItem('b_id');
    if (raw == null) return null;
    try { return JSON.parse(raw); } catch { return raw; }
};

// legacy dashboard counters (kept for any old callers)
export async function get_branch_dashboard() {
    try {
        const response = await fetch(HTTPURL + `api/branches/get-dashboard-data/?b_id=${getBranchId()}`);
        const responseData = await response.json();
        if (responseData.status) {
            // toast.success(responseData?.message);
        } else {
            toast.error(responseData?.message);
        }
        return responseData;
    } catch (error) {
        console.log(error.message);
        return error.message;
    }
}

// rich branch dashboard (attention items, today's classes, at-a-glance)
export async function get_branch_dashboard_v2() {
    try {
        const response = await fetch(HTTPURL + `api/branches/dashboard?branch_id=${getBranchId()}`);
        return await response.json();
    } catch (error) {
        return { status: false, message: error.message };
    }
}
// Enrolment requests and free-assessment bookings from the website.
//
// Neither is an enrolment. They are people waiting on a phone call from this
// branch, which is why they belong on the dashboard rather than in a list
// someone has to remember to open.
export async function get_enrolment_requests() {
    try {
        const response = await fetch(HTTPURL + `api/branch/enrolment-requests?branch_id=${getBranchId()}`);
        return await response.json();
    } catch (error) {
        return { status: false, message: error.message };
    }
}

export async function get_assessment_bookings() {
    try {
        const response = await fetch(HTTPURL + `api/branch/assessment-bookings?branch_id=${getBranchId()}`);
        return await response.json();
    } catch (error) {
        return { status: false, message: error.message };
    }
}

export async function set_request_status(kind, id, status) {
    try {
        const response = await fetch(HTTPURL + 'api/branch/request-status', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ kind, id, status }),
        });
        const responseData = await response.json();
        if (!responseData.status) toast.error(responseData?.message);
        return responseData;
    } catch (error) {
        return { status: false, message: error.message };
    }
}

// --- online payment settings for this campus -------------------------------
//
// The secret key is never sent back, only whether one is stored. Saving with
// the secret field left blank keeps the one already there.
export async function get_payment_settings() {
    try {
        const res = await fetch(HTTPURL + `api/branch/payment-settings?branch_id=${getBranchId()}`);
        return await res.json();
    } catch (error) {
        console.log(error.message);
        return { status: false, message: error.message, data: null };
    }
}

export async function save_payment_settings(payload) {
    try {
        const res = await fetch(HTTPURL + 'api/branch/payment-settings', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...payload, branch_id: getBranchId() }),
        });
        const data = await res.json();
        if (data?.status) toast.success(data?.message);
        else toast.error(data?.message);
        return data;
    } catch (error) {
        console.log(error.message);
        return { status: false, message: error.message, data: null };
    }
}
